import ApiService from 'services/ApiService/ApiService';
import getMessagingServiceInstance from 'services/MessagingService/MessagingService';
import { GAME_ACTION_DONE, PLAY_RESPONSE } from 'services/MessagingService/EventNames';
import parseCatch from 'utils/parseCatch';
import { SOUND_NOTIFICATION_TYPES } from 'enum/helpers';
import Game, { Action } from 'services/GamesService/Game';
import {
  computeEndpoint,
  TOKEN_KENO_ACTION,
  TOKEN_KENO_START,
  TOKEN_KENO_STOP,
} from 'services/GamesService/GamesService';


export default class TokenKeno extends Game {

  constructor() {
    super(getMessagingServiceInstance());
  }

  start: Action = async({ roomName, token, ...rest }) => {
    const url = computeEndpoint(roomName, TOKEN_KENO_START);
    const params = { token };
    const data = {
      o: Object.values(rest),
      token,
    };

    try {
      await ApiService.post(url, {
        params,
        data,
        withCredentials: false,
      });
      this.messagingService.emit(GAME_ACTION_DONE);
    } catch (error) {
      parseCatch(error);
    }
  };

  stop: Action = async({ roomName, token }) => {
    const url = computeEndpoint(roomName, TOKEN_KENO_STOP);
    const params = { token };
    const data = { token };

    try {
      await ApiService.post(url, {
        data,
        params,
        withCredentials: false,
      });
      this.messagingService.emit(GAME_ACTION_DONE);
      await this.getActiveGamesInfo(roomName, token);
    } catch (error) {
      parseCatch(error);
    }
  };

  action: Action = async({ roomName, token, index }) => {
    const url = computeEndpoint(roomName, TOKEN_KENO_ACTION);
    const data = {
      token,
      i: index,
    };
    const params = { token };

    try {
      await ApiService.post(url, {
        params,
        data,
        withCredentials: false,
      });
      this.messagingService.emit(PLAY_RESPONSE, SOUND_NOTIFICATION_TYPES.TOKEN_KENO);
    } catch (error) {
      parseCatch(error);
    }
  };
}
